// actions/products.actions.ts
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateProjectDto } from 'src/app/components/user/projects/dto/project.create.dto';

import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';
import { OutlineTreeNode } from './content.reducer';
import { CreateProjectContentDto } from 'src/app/components/user/projects/project-item/project-dashboard/project-outline/dto/content.create.dto';


export const ProjectContentActions = createActionGroup({
  source: 'Load Projects Content',
  events: {
    load: props<{ projectId: number }>(),
    loadSuccess: props<{ contents: OutlineTreeNode[] }>(),
    loadFailure: props<{ error: any }>(),

  },
});


export const ProjectContentItemCreateActions = createActionGroup({
  source: 'Create Project Content Item',
  events: {
    create: props<{ projectId: number, payload: CreateProjectContentDto }>(),
    success: props<{ item: OutlineTreeNode }>(),
    failure: props<{ error: any }>(),

  },
});


export const ApplyTemplateToProjectAction = createActionGroup({
  source: 'Apply Template To Project Actions',
  events: {
    apply: props<{ projectId: number, payload: {contents: OutlineTreeNode[]} }>(),
    success: props<{ contents: OutlineTreeNode[] }>(),
    failure: props<{ error: any }>(),

  },
});



